import * as Yup from 'yup'

export type JoinRoomFormValues = {
  inviteCode: string
}

export const JoinRoomInitialValues: JoinRoomFormValues = {
  inviteCode: '',
}

export const JoinRoomValidationSchema = Yup.object({
  inviteCode: Yup.string().required('Please enter a valid Invite Code'),
})
